export default __webpack_public_path__ + "static/media/lock-rounded.a097f44d.svg";